import { Button, Dialog, DialogBaseProps } from '@optimus-web/core';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useInvalidateUserProfile } from '../../hooks/useInvalidateUserProfile';

export const ResetMFADialog = ({
    userId,
    active,
    onClose,
}: { userId: string } & Pick<DialogBaseProps, 'active' | 'onClose'>) => {
    const invalidateUserProfile = useInvalidateUserProfile();

    const resetAuthenticator = useRepositoryMutation('userProfiles', 'enterpriseResetAuthenticator', {
        onSuccess: () => {
            showSuccessAlert({
                title: <LocalizedText textKey={TextKey.TwoFactorAuthenticationResetSuccess} />,
                description: <LocalizedText textKey={TextKey.TwoFactorAuthenticationResetSuccessDescription} />,
            });

            invalidateUserProfile(userId);
        },
    });

    const handleReset = () => resetAuthenticator.mutate({ userId }, { onSettled: () => onClose });

    return (
        <Dialog
            active={active}
            title={<LocalizedText textKey={TextKey.TwoFactorAuthenticationReset} />}
            footer={{
                secondary: (
                    <Button onClick={onClose} variant="tertiary" size="medium" type="submit">
                        <LocalizedText textKey={TextKey.Cancel} />
                    </Button>
                ),
                primary: (
                    <Button
                        onClick={handleReset}
                        variant="primary"
                        size="medium"
                        loading={resetAuthenticator.isPending}
                        type="submit"
                    >
                        <LocalizedText textKey={TextKey.Reset} />
                    </Button>
                ),
            }}
            onClose={onClose}
            size="small"
        >
            <LocalizedText textKey={TextKey.TwoFactorAuthenticationResetDescription} />
        </Dialog>
    );
};
